import { useEffect, useMemo, useCallback, useState } from 'react';
import { useSetFcmToken } from '../../hooks/use-setfcmtoken';
import { useGetNotificationHistory } from '../../hooks/use-getNotificationHistory';
import { useSubscriberId } from '../../hooks/use-getSubcriberId';

import { useBuildVars } from 'mf_core/config';

export const FCMEnabler = ({
  // chat,
  fcmToken,
  firebaseReady,
  latestChat,
  setChat,
  setFcmtoken,
  setHistoryChat,
}: any) => {
  const setFcmTokentoDb = useSetFcmToken();
  const { data: NotificationHistoryInfo, isFetched } =
    useGetNotificationHistory();
  const { data: subscriberIdData } = useSubscriberId();

  const { buildEnvironment } = useBuildVars();

  type FirebaseConfig = {
    apiKey: string;
    appId: string;
    authDomain: string;
    messagingSenderId: string;
    projectId: string;
    storageBucket: string;
  };
  const [subscriberId, setSubscriberId] = useState(() => {
    return localStorage.getItem('subscriberid') || null;
  });
  useEffect(() => {
    if (subscriberIdData) {
      const newSubscriberId = subscriberIdData;
      if (newSubscriberId && newSubscriberId !== subscriberId) {
        localStorage.setItem('subscriberid', newSubscriberId);
        setSubscriberId(newSubscriberId);
      }
    }
  }, [subscriberIdData, subscriberId]);
  const firebaseConfig: FirebaseConfig = useMemo(() => {
    return buildEnvironment === 'development' ||
      buildEnvironment === 'staging' ||
      buildEnvironment === 'productionbeta'
      ? {
          apiKey: 'AIzaSyD2gPW474Ymmfw45eraB9OvWi2w9DqpiyU',
          appId: '1:259420669198:web:90432edeb5e2e5cf7dc35f',
          authDomain: 'imgcp-369230c31642aca9.firebaseapp.com',
          messagingSenderId: '259420669198',
          projectId: 'imgcp-369230c31642aca9',
          storageBucket: 'imgcp-369230c31642aca9.appspot.com',
        }
      : {
          apiKey: 'AIzaSyBe9EYHwIudbX3tbu6ZxdDg4MrDOagZ_tQ',
          appId: '1:754257395430:web:563d1fa861596ea1aac527',
          authDomain: 'imgcp-8d41e6bed7a49a8e.firebaseapp.com',
          messagingSenderId: '754257395430',
          projectId: 'imgcp-8d41e6bed7a49a8e',
          storageBucket: 'imgcp-8d41e6bed7a49a8e.appspot.com',
        };
  }, [buildEnvironment]);

  const handleSetFcmtoken = useCallback(
    (token: string) => {
      localStorage.setItem('fcmtoken', token);
      setFcmtoken(token);
    },
    [setFcmtoken]
  );
  type ChatMessage = {
    content?: string;
    createdDate?: string;
    data?: {
      content?: string;
      title?: string;
    };
    fcmMessageId?: string;
    messageId?: string;
    title?: string;
  };
  const handleSetChat = useCallback(
    (updatedChats: ChatMessage[]) => {
      setChat(
        updatedChats.map((item: any) => ({
          ...item,
          content: item?.data?.content,
          createdDate: item?.createdDate || new Date().toISOString(),
          isRead: item?.isRead,
          title: item?.data?.title,
        }))
      );
    },
    [setChat]
  );
  const handleSetChatFromHistoryApi = useCallback(
    (updatedChats: ChatMessage[]) => {
      setHistoryChat(
        updatedChats.map((item: any) => ({
          ...item,
          content: item?.content,
          createdDate: item?.createdDate || new Date().toISOString(),
          isRead: item?.isRead,
          notificationId: item?.notificationId,
          title: item?.title,
        }))
      );
    },
    [setHistoryChat]
  );
  const processIncomingMessage = (events: any[]) => {
    if (events && Array.isArray(events)) {
      const updatedChats = [...events];

      events.forEach((event) => {
        if (event) {
          const isDuplicate = updatedChats.some(
            (item) => item?.data?.notificationId === event.notificationId
          );

          if (!isDuplicate) {
            updatedChats.push({
              content: event.content,
              // messageId: event.messageId,
              createdDate: event.createdDate || new Date().toISOString(),
              isRead: event?.isRead,
              notificationId: event?.notificationId,
              title: event.title,
            });
          }
        }
      });
      // Update the chat with new messages
      handleSetChatFromHistoryApi(updatedChats);
    }
  };
  useEffect(() => {
    processIncomingMessage(NotificationHistoryInfo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [NotificationHistoryInfo, isFetched]);
  useEffect(() => {
    if (!firebaseReady) return;

    const firebase = (window as any).firebase;
    if (!firebase) return;

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    const messaging = firebase.messaging();
    (window as any).firebaseMessaging = messaging;

    const setupFCM = () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('./app/firebase-messaging-sw.js')
          .then(async (registration) => {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
              const VAPID_KEY =
                'BNdCrafNXKsqW_ABEgEOJJeAqt12ARqCNKi_RwbRmu0jBJIN5HuZNCyxBkfU-4s6wmuNs-NrwpRYgLYoNqO1MMc';

              const token = await messaging.getToken({
                serviceWorkerRegistration: registration,
                vapidKey: VAPID_KEY,
              });

              if (token) {
                handleSetFcmtoken(token);
              }
            }

            messaging.onMessage((payload: any) => {
              // const { body, title } = payload.notification;
              // new Notification(title, { body });

              const updatedChats = [...latestChat.current];
              const isDuplicate = updatedChats.some((item) => {
                return (
                  (item.messageId && item.messageId === payload.messageId) ||
                  (item.fcmMessageId &&
                    item.fcmMessageId === payload.messageId) ||
                  (item.title && item.title === payload.data.title) ||
                  (item.content && item.content === payload.data.content) ||
                  (item.noti && item.content === payload.data.content)
                );
              });

              if (!isDuplicate) {
                updatedChats.push(payload);
                handleSetChat(updatedChats);
              }
            });
          })
          .catch((error) => {
            console.error('Service Worker registration failed:', error);
          });
      }
    };

    setupFCM();

    return () => {
      messaging.onMessage(() => {});
    };
  }, [
    firebaseReady,
    firebaseConfig,
    handleSetFcmtoken,
    handleSetChat,
    latestChat,
  ]);

  const registerFCMToken = async () => {
    try {
      const result = localStorage.getItem('okta-token-storage');
      let tokenData;
      if (result !== null) {
        tokenData = JSON.parse(result);
      }

      const token = tokenData?.accessToken?.accessToken;
      if (!token) {
        throw new Error('Failed to acquire access token.');
      }

      const TokenAvailable = localStorage.getItem('fcmtoken');
      const requestBody = {
        fcmToken: TokenAvailable,
        subscriberId: subscriberId,
      };

      if (TokenAvailable && subscriberId) {
        setFcmTokentoDb.mutate(requestBody, {
          onError: () => {
            // Handle error case
          },
          onSuccess: () => {
            // Handle success case
          },
        });
      }
    } catch (error) {
      console.error('Error registering FCM Token:', error);
    }
  };

  useEffect(() => {
    const registerToken = async () => {
      if (fcmToken) {
        await registerFCMToken();
      }
    };
    registerToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fcmToken]);

  return null;
};
